export default {
  'eventEngine.title': '事件引擎',
  'eventEngine.subTitle': '查看平台事件流水、订阅关系与各消费者的消费情况',
  'eventEngine.forbidden.title': '无权访问事件引擎',
  'eventEngine.forbidden.subTitle':
    '该视图跨租户展示平台事件，仅对企业管理员开放，请联系管理员开通。',

  'eventEngine.tab.events': '事件流水',
  'eventEngine.tab.consumptions': '消费记录',
  'eventEngine.tab.subscriptions': '订阅关系',

  'eventEngine.stat.totalEvents': '事件总数',
  'eventEngine.stat.pendingEvents': '待派发事件',
  'eventEngine.stat.failedConsumptions': '消费失败及死信',
  'eventEngine.stat.activeSubscriptions': '生效订阅',

  'eventEngine.field.type': '事件类型',
  'eventEngine.field.status': '状态',
  'eventEngine.field.source': '来源服务',
  'eventEngine.field.subject': '事件对象',
  'eventEngine.field.tenantId': '租户标识',
  'eventEngine.field.appId': '应用标识',
  'eventEngine.field.operatorId': '操作人标识',
  'eventEngine.field.eventversion': '事件版本',
  'eventEngine.field.ceId': '事件 ID',
  'eventEngine.field.consumer': '消费者',
  'eventEngine.field.pattern': '订阅模式',
  'eventEngine.field.serviceName': '业务服务',
  'eventEngine.field.callbackUrl': '回调地址',
  'eventEngine.field.retryCount': '重试次数',
  'eventEngine.field.lastError': '最近错误',
  'eventEngine.field.nextRetryAt': '下次重试时间',
  'eventEngine.field.consumedAt': '消费成功时间',
  'eventEngine.field.failedAt': '消费失败时间',
  'eventEngine.field.deadAt': '进入死信时间',
  'eventEngine.field.publishedAt': '派发时间',
  'eventEngine.field.time': '事件发生时间',
  'eventEngine.field.occurredAt': '事件发生时间',
  'eventEngine.field.recordedAt': '记录时间',
  'eventEngine.field.createdAt': '创建时间',
  'eventEngine.field.updatedAt': '更新时间',
  'eventEngine.field.action': '操作',
  'eventEngine.field.unknown': '未知',

  'eventEngine.placeholder.typePrefix': '按前缀匹配，如 tenant.',
  'eventEngine.placeholder.pattern': '如 tenant.# 或 member.*',
  'eventEngine.placeholder.source': '全部来源服务',

  'eventEngine.action.detail': '详情',
  'eventEngine.detail.eventTitle': '事件详情',
  'eventEngine.detail.consumptionTitle': '消费记录详情',
  'eventEngine.detail.payload': '事件载荷',
  'eventEngine.detail.rawEvent': '完整事件',
  'eventEngine.detail.copyJson': '复制 JSON',
  'eventEngine.detail.copied': '已复制',
  'eventEngine.detail.emptyPayload': '该事件没有载荷',
  'eventEngine.detail.lastError': '最近错误',

  'eventEngine.outboxStatus.pending': '待派发',
  'eventEngine.outboxStatus.published': '已派发',
  'eventEngine.outboxStatus.failed': '派发失败',

  'eventEngine.inboxStatus.processing': '投递中',
  'eventEngine.inboxStatus.consumed': '已消费',
  'eventEngine.inboxStatus.failed': '待重试',
  'eventEngine.inboxStatus.dead': '死信',

  'eventEngine.subscriptionStatus.active': '生效',
  'eventEngine.subscriptionStatus.disabled': '已停用',

  'eventEngine.action.retry': '重试',
  'eventEngine.retry.singleTitle': '确认重试？',
  'eventEngine.retry.singleConsumptionDesc':
    '该记录将重新排队投递，已成功消费的会自动跳过。',
  'eventEngine.retry.singleEventDesc':
    '该事件将重新投递到消息队列，重复投递会在消费端去重。',
  'eventEngine.retry.batchAction': '按筛选批量重试',
  'eventEngine.retry.batchTitle': '确认批量重试？',
  'eventEngine.retry.batchContent':
    '当前筛选条件共匹配 {count} 条记录，其中仅可重试状态的会被重新排队，其余保持不变。该操作不可撤销。',
  'eventEngine.retry.confirm': '确认重试',
  'eventEngine.retry.cancel': '取消',
  'eventEngine.retry.success': '已重新排队 {count} 条记录',

  'eventEngine.preset.last1Hour': '最近 1 小时',
  'eventEngine.preset.today': '今天',
  'eventEngine.preset.last24Hours': '最近 24 小时',
  'eventEngine.preset.last3Days': '最近 3 天',
  'eventEngine.preset.last7Days': '最近 7 天',

  'eventEngine.action.viewConsumptions': '查看消费记录',
  'eventEngine.action.viewSourceEvent': '查看源事件',
  'eventEngine.action.retrySelected': '重试所选 ({count})',
  'eventEngine.retry.selectedTitle': '确认重试选中的记录？',
  'eventEngine.retry.selectedContent':
    '将重试选中的 {count} 条记录，已成功消费的会自动跳过。',
  'eventEngine.retry.selectedSuccess':
    '批量重试完成：成功 {success} 条，失败 {failed} 条',
  'eventEngine.retry.notRetryable': '当前状态不可重试',
  'eventEngine.retry.inDrawerAction': '重试此记录',

  'eventEngine.refresh.title': '刷新统计',
  'eventEngine.refresh.lastUpdated': '更新于 {time}',
  'eventEngine.refresh.autoRefresh': '定时刷新',
  'eventEngine.refresh.off': '关闭',
  'eventEngine.refresh.30s': '30秒',
  'eventEngine.refresh.60s': '60秒',

  'eventEngine.detail.searchPayload': '搜索载荷内容...',
  'eventEngine.detail.downloadJson': '下载 JSON',
  'eventEngine.detail.wrapLines': '自动换行',
  'eventEngine.detail.expandError': '展开错误详情',
  'eventEngine.detail.collapseError': '收起错误详情',
  'eventEngine.stat.cardTip': '点击可按此状态筛选',

  'eventEngine.action.delete': '删除',
  'eventEngine.subscription.deleteTitle': '确认删除该订阅？',
  'eventEngine.subscription.deleteDesc':
    '删除后该消费者不再收到事件。订阅由业务服务启动时自动注册，服务若仍在运行，下次重启会重新注册；待重试的消费记录会在下次重试时转为死信。',
  'eventEngine.subscription.confirm': '确认删除',
  'eventEngine.subscription.deleted': '订阅已删除',
  'eventEngine.subscription.deleteMissing': '该订阅已不存在，列表已刷新',

  'eventEngine.delete.singleTitle': '确认删除这条死信？',
  'eventEngine.delete.singleDesc':
    '记录将被永久删除，该事件不会再补送给这个消费者。仅死信状态可删除。',
  'eventEngine.delete.batchAction': '批量删除死信',
  'eventEngine.delete.batchTitle': '确认批量删除死信？',
  'eventEngine.delete.batchContent':
    '当前筛选条件共匹配 {count} 条记录，其中死信状态的会被永久删除，其余保持不变。删除后这些事件不会再补送给对应消费者，该操作不可撤销。',
  'eventEngine.delete.confirm': '确认删除',
  'eventEngine.delete.success': '已删除 {count} 条死信',
};
